<!-- @format -->

<template>
  <nav
    class="bg-white flex justify-center p-4 border-b-2 border-gamma-blue"
    v-if="!check_route"
  >
    <!-- Step circles -->
    <div
      class="step-circle"
      v-for="(page, index) in pages"
      :key="index"
      @click="goToStep(index)"
    >
      <div
        class="step-number"
        :class="{ active: $store.state.currentStep === index }"
      >
        {{ index + 1 }}
      </div>
      <!-- <div class="step-title">{{ page.title }}</div> -->
    </div>

    <!-- Navigation buttons -->
    <!-- <button @click="goToPreviousPage" :disabled="$store.state.currentStep === 0"> 
      <img src="./assets/images/arrowLeftBlue.png">
    </button>

    <button @click="goToNextPage" :disabled="$store.state.currentStep === pages.length - 1">
      <img src="./assets/images/arrowRightBlue.png">
    </button>  -->
  </nav>
  <router-view />
</template>

<script>
import "./assets/tailwind.css";
import { mapState, mapMutations } from "vuex";

export default {
  name: "App",
  data() {
    return {
      pages: [
        {
          name: "Home",
          title: "Hoe werk het",
          image: "./assets/images/gridWhite.png",
          route: "/gamma",
        },
        {
          name: "Sizes",
          title: "Verhuizing",
          image: "./assets/images/gridWhite.png",
          route: "/size",
        },
        {
          name: "Details",
          title: "Jouw gegevens",
          image: "./assets/images/infoWhite.png",
          route: "/details",
        },
        {
          name: "Offers",
          title: "Jouw voorstel(len)",
          image: "./assets/images/calculatorWhite.png",
          route: "/offers",
        },
      ],
      check_route: false,
    };
  },
  computed: {
    ...mapState([
      "currentQuote",
      "submitData",
      "quotes",
      "instantCalculation",
      "popup",
    ]),
  },
  mounted() {
    const currentPath = window.location.pathname;
    const pathName = currentPath.replace("/gamma-verhuizen/", "").trim();
    if (pathName == "thankyou") {
      this.check_route = true;
    }
  },
  methods: {
    ...mapMutations([
      "changeSubmitData",
      "completeStep",
      "changePopup",
      "changeCalculating",
    ]),
    goToPreviousPage() {
      if (this.$store.state.currentStep > 0) {
        this.$router.push({
          name: this.pages[this.$store.state.currentStep - 1].name,
        });
      }
    },
    goToNextPage() {
      if (this.$store.state.currentStep < this.pages.length - 1) {
        this.$router.push({
          name: this.pages[this.$store.state.currentStep + 1].name,
        });
      }
    },
    goToStep(index) {
      if (index == 0 || index == 1) this.changeCalculating(false);
      this.$router.push({ name: this.pages[index].name });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Overpass&display=swap");
* {
  outline: none !important;
}
button {
  font-family: Overpass !important;
}
h1 {
  font-family: Overpass !important;
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 42px;
}
h2 {
  font-family: Overpass !important;
  font-style: normal;
  font-weight: 800;
  font-size: 26px;
  line-height: 32px;
}
h3 {
  font-family: Overpass !important;
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  line-height: 30px;
}
p {
  font-family: Overpass !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 28px;
}
.inpt {
  background: #f0f2f6;
  border: 1px solid #6d818d;
  box-sizing: border-box;
  border-radius: 8px;
  left: 0px;
  top: 0px;
  border-radius: 8px;
  /* padding-left: 10px; */
  height: 31px;
}
.inptError {
  background: #ffffff;
  border: 1px solid #e55026;
  box-sizing: border-box;
  border-radius: 8px;
  left: 0px;
  top: 0px;
  border-radius: 8px;
  padding-left: 10px;
  height: 31px;
}
.inpt:not(:placeholder-shown) {
  /* border: 1px solid #003878; */
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: left;
  position: static;

  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 183.84%;
}
.inpt:focus {
  background: #ffffff;
  /* primary */
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: left;
  position: static;

  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 183.84%;
  /* identical to box height, or 29px */

  display: flex;
  align-items: center;

  /* black */

  color: #000000;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 2px;

  border: 1px solid #003878;
  box-sizing: border-box;
  /* button/focus */

  box-shadow: 0px 0px 0px 3px rgba(0, 56, 120, 0.2);
  border-radius: 8px;
}
.inpt::placeholder {
  position: absolute !important;
  width: 160px !important;
  height: 28px !important;
  left: 10px !important;
  top: calc(50% - 28px / 2) !important;

  font-family: Overpass !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 28px !important;
  /* identical to box height, or 175% */

  display: flex !important;
  align-items: flex-end !important;

  /* grey/400 */

  color: #6d818d;
}
.step-circle {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #003878;
  font-weight: 700;
  font-size: 20px;
  border: 1px solid #003878;
}

.step-number.active {
  background-color: #74c202; /* Active circle color */
  border: none;
  color: white;
}

.step-title {
  margin-top: 5px;
  font-size: 12px;
}
.radius-50 {
  border-radius: 50%;
}
.left-82 {
  left: 81%;
  margin-top: 5rem;
}
</style>
